import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry, setSentryCorrelationId } from './lib/sentry'
import { setupGlobalErrorHandlers } from './lib/global-error-handlers'
import { getCorrelationId } from './lib/correlation'
import './index.css'
import App from './App.tsx'

initSentry('customer-portal');
setupGlobalErrorHandlers();
setSentryCorrelationId(getCorrelationId());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
